import { render, staticRenderFns } from "./EventStand.vue?vue&type=template&id=4a619ed8"
import script from "./EventStand.vue?vue&type=script&lang=js"
export * from "./EventStand.vue?vue&type=script&lang=js"
import style0 from "./EventStand.vue?vue&type=style&index=0&id=4a619ed8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports